import {AppState, Auth0Provider} from '@auth0/auth0-react';
import {ConfigProvider} from 'antd';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './App.scss';
import {BrowserRouter} from 'react-router-dom';

import App from './App';
import {getConfig} from './config';
// import {Routes} from './constants/Routes';
import reportWebVitals from './reportWebVitals';
import './libraries/I18N/config';
import history from './utils/history';

// import history from './utils/history';

const config = getConfig();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const onRedirectCallback = (appState: AppState) => {
  history.push(
    appState?.returnTo
      ? `${window.location.origin}${appState.returnTo}`
      : `${window.location.origin}`
  );
};

root.render(
  <BrowserRouter>
    <Auth0Provider
      domain={config.domain}
      clientId={config.clientId}
      onRedirectCallback={(appState) => {
        onRedirectCallback(appState as AppState);
      }}
      authorizationParams={{
        redirect_uri: `${window.location.origin}`
      }}
      // useRefreshTokens={true}
      // cacheLocation="localstorage"
    >
      <ConfigProvider
        theme={{
          token: {
            fontFamily: 'Montserrat'
          }
        }}
      >
        <App />
      </ConfigProvider>
    </Auth0Provider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
